<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="80px">
    <el-form-item label="课程分类" prop="categoryId">
      <el-input v-model="dataForm.categoryId" placeholder="课程分类"></el-input>
    </el-form-item>
    <el-form-item label="课程知识点" prop="topic">
      <el-input v-model="dataForm.topic" placeholder="课程知识点"></el-input>
    </el-form-item>
    <el-form-item label="课程内容" prop="content">
      <el-input v-model="dataForm.content" placeholder="课程内容"></el-input>
    </el-form-item>
    <el-form-item label="课时" prop="period">
      <el-input v-model="dataForm.period" placeholder="课时"></el-input>
    </el-form-item>
    <el-form-item label="相关资源" prop="resourceIds">
      <el-input v-model="dataForm.resourceIds" placeholder="相关资源"></el-input>
    </el-form-item>
    <el-form-item label="排序字段" prop="sort">
      <el-input v-model="dataForm.sort" placeholder="排序字段"></el-input>
    </el-form-item>
    <el-form-item label="删除标志 0.删除" prop="delFlag">
      <el-input v-model="dataForm.delFlag" placeholder="删除标志 0.删除"></el-input>
    </el-form-item>
    <el-form-item label="创建时间" prop="createTime">
      <el-input v-model="dataForm.createTime" placeholder="创建时间"></el-input>
    </el-form-item>
    <el-form-item label="更新时间" prop="updateTime">
      <el-input v-model="dataForm.updateTime" placeholder="更新时间"></el-input>
    </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data () {
      return {
        visible: false,
        dataForm: {
          id: 0,
          categoryId: '',
          topic: '',
          content: '',
          period: '',
          resourceIds: '',
          sort: '',
          delFlag: '',
          createTime: '',
          updateTime: ''
        },
        dataRule: {
          categoryId: [
            { required: true, message: '课程分类不能为空', trigger: 'blur' }
          ],
          topic: [
            { required: true, message: '课程知识点不能为空', trigger: 'blur' }
          ],
          content: [
            { required: true, message: '课程内容不能为空', trigger: 'blur' }
          ],
          period: [
            { required: true, message: '课时不能为空', trigger: 'blur' }
          ],
          resourceIds: [
            { required: true, message: '相关资源不能为空', trigger: 'blur' }
          ],
          sort: [
            { required: true, message: '排序字段不能为空', trigger: 'blur' }
          ],
          delFlag: [
            { required: true, message: '删除标志 0.删除不能为空', trigger: 'blur' }
          ],
          createTime: [
            { required: true, message: '创建时间不能为空', trigger: 'blur' }
          ],
          updateTime: [
            { required: true, message: '更新时间不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      init (id) {
        this.dataForm.id = id || 0
        this.visible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
          if (this.dataForm.id) {
            this.$http({
              url: this.$http.adornUrl(`/business/course/info/${this.dataForm.id}`),
              method: 'get',
              params: this.$http.adornParams()
            }).then(({data}) => {
              if (data && data.code === 0) {
                this.dataForm.categoryId = data.course.categoryId
                this.dataForm.topic = data.course.topic
                this.dataForm.content = data.course.content
                this.dataForm.period = data.course.period
                this.dataForm.resourceIds = data.course.resourceIds
                this.dataForm.sort = data.course.sort
                this.dataForm.delFlag = data.course.delFlag
                this.dataForm.createTime = data.course.createTime
                this.dataForm.updateTime = data.course.updateTime
              }
            })
          }
        })
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            this.$http({
              url: this.$http.adornUrl(`/business/course/${!this.dataForm.id ? 'save' : 'update'}`),
              method: 'post',
              data: this.$http.adornData({
                'id': this.dataForm.id || undefined,
                'categoryId': this.dataForm.categoryId,
                'topic': this.dataForm.topic,
                'content': this.dataForm.content,
                'period': this.dataForm.period,
                'resourceIds': this.dataForm.resourceIds,
                'sort': this.dataForm.sort,
                'delFlag': this.dataForm.delFlag,
                'createTime': this.dataForm.createTime,
                'updateTime': this.dataForm.updateTime
              })
            }).then(({data}) => {
              if (data && data.code === 0) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.visible = false
                    this.$emit('refreshDataList')
                  }
                })
              } else {
                this.$message.error(data.msg)
              }
            })
          }
        })
      }
    }
  }
</script>
